<div class="row">
  <div class="fw-bold" [class]="rearrangeColumns ? 'col-12 order-0' : 'col'">
    <div *scText="monthLabel"></div>
  </div>
  @if (hasDiscount) {
    <div
      class="discounted-values-text"
      [class]="rearrangeColumns ? 'col-12 order-2' : 'col-auto text-end'"
    >
      <s>{{ monthlyAmount | currency: 'EUR' : 'symbol' : '1.0-0' }},-</s>
    </div>
  } @else {
    <div
      class="fw-bold font-size-lg"
      [class]="rearrangeColumns ? 'col-12 order-3' : 'col-auto text-end'"
    >
      {{ beforeDiscountMonthlyAmount | currency: 'EUR' : 'symbol' : '1.0-0' }},-
    </div>
  }
  @if (!rearrangeColumns) {
    <div class="col-12"></div>
  }
  <div
    class="text-body-secondary"
    [class]="rearrangeColumns ? 'col-12 order-1 mb-1' : 'col'"
  >
    <div *scText="beforeDiscountMonthLabel"></div>
  </div>

  @if (hasDiscount) {
    <ng-container [ngTemplateOutlet]="beforeDiscountAmount"></ng-container>
  }
</div>

<ng-template #beforeDiscountAmount>
  <div
    class="fw-bold font-size-lg"
    [class]="rearrangeColumns ? 'col-12 order-3' : 'col-auto text-end'"
  >
    {{ beforeDiscountMonthlyAmount | currency: 'EUR' : 'symbol' : '1.0-0' }},-
  </div>
</ng-template>
